// @flow
/**
 * @module Actions/Categoria
 * @desc Actions for Categoria
 */
import { ActionTypes } from '../utils/constants';

/**
 * Fetch version
 * @param {string} tipo
 * @param {string} modelo
 * @returns {Object}
 */
export function fetchVersion(tipo, modelo) {
  return {
    type: ActionTypes.FETCH_VERSION_REQUEST,
    payload: { tipo, modelo }
  };
}

/**
 * Fetch version
 * @param {string} tipo
 * @param {string} modelo
 * @returns {Object}
 */
export function fetchVersionSuccess(data) {
    return {
      type: ActionTypes.FETCH_VERSION_SUCCESS,
      payload: data
    };
  }


/**
 * Fetch version
 * @returns {Object}
 */
export function fetchVersionFailure() {
    return {
      type: ActionTypes.FETCH_VERSION_FAILURE, 
    };
}

/**
 * Fetch version
 * @returns {Object}
 */
 export function fetchCoupon(coupon, codigoAnio) {
  return {
    type: ActionTypes.REQUEST_COUPON,
    payload: { coupon, codigoAnio }
  };
}


/**
 * Fetch version
 * @returns {Object}
 */
 export function fetchCouponSuccess(coupon) {
  return {
    type: ActionTypes.REQUEST_COUPON_SUCCESS,
    payload: { coupon }
  };
}


/**
 * Fetch version
 * @returns {Object}
 */
 export function resetCoupon() {
  return {
    type: ActionTypes.RESET_COUPON_SUCCESS,
  };
}

/**
 * Fetch version
 * @returns {Object}
 */
 export function sendCouponInfo(form) {
  return {
    type: ActionTypes.SEND_COUPON_REQUEST,
    payload: { form }
  };
}


/**
 * Fetch version
 * @returns {Object}
 */
 export function sendCouponFinalized() {
  return {
    type: ActionTypes.SEND_COUPON_DONE,
  };
}


/**
 * Fetch version
 * @returns {Object}
 */
 export function sendDescuento(overridenCampaing) {
  return {
    type: ActionTypes.SET_DESCUENTO_WEB,
    payload: {
      overridenCampaing
    }
  };
}

/**
 * Fetch version
 * @returns {Object}
 */
 export function resetDescuento() {
  return {
    type: ActionTypes.RESET_DESCUENTO_WEB,
  };
}
